export default __webpack_public_path__ + "static/media/snl-js.7cb9316d.jpg";